import { render, staticRenderFns } from "./SurfSecondTab.vue?vue&type=template&id=6ae04b64&scoped=true"
import script from "./SurfSecondTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfSecondTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfSecondTab.vue?vue&type=style&index=0&id=6ae04b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae04b64",
  null
  
)

export default component.exports